import { roundTo } from "commons/ultilities";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { IProductProperties } from "mobx-stores/_models/products/product";
import { IAddEditWorkOrderPo } from "mobx-stores/_models/work-order-po/work-order-po";
import { useMemo } from "react";

export interface useCalcTotalPageWeightProps {
  getControl: (fieldName: keyof IAddEditWorkOrderPo) => IControl;
  selectedProduct: IProductProperties | null;
}

export const useCalcTotalPageWeight = ({
  getControl,
  selectedProduct,
}: useCalcTotalPageWeightProps) => {
  const calcTotalPaperWeight = (
    productOverride?: IProductProperties | null,
  ) => {
    const firstFullPaperAmount =
      getControl("poItemFirstFullPaperAmount")?.value ?? 0;
    const secondFullPaperAmount =
      getControl("poItemSecondFullPaperAmount")?.value ?? 0;
    const product = productOverride ?? selectedProduct;
    const process = product?.process;
    const gsmStandard = product?.material?.gsmStandard;
    let total =
      (process?.firstFullPaperSize ?? 0) *
        (process?.firstFullPaperLength ?? 0) *
        firstFullPaperAmount +
      (process?.secondFullPaperSize ?? 0) *
        (process?.secondFullPaperLength ?? 0) *
        secondFullPaperAmount;

    return roundTo((gsmStandard ?? 0) * total / 1_000_000_000, 2);
  };

  return {
    calcTotalPaperWeight,
  };
};

export const useCalcFirstFullPaperAmountPageWeight = ({
  poItemFirstFullPaperAmount,
  selectedProduct,
}: {
  poItemFirstFullPaperAmount: number;
  selectedProduct: IProductProperties | null;
}) => {
  const firstFullPaperAmountPageWeight = useMemo(() => {
    const firstFullPaperAmount = poItemFirstFullPaperAmount;
    const process = selectedProduct?.process;
    const gsmStandard = selectedProduct?.material?.gsmStandard;
    return (
      ((gsmStandard ?? 0) *
        (process?.firstFullPaperSize ?? 0) *
        (process?.firstFullPaperLength ?? 0) *
        firstFullPaperAmount) /
      1_000_000_000
    );
  }, [
    poItemFirstFullPaperAmount,
    selectedProduct?.process,
    selectedProduct?.material?.gsmStandard,
  ]);

  return {
    firstFullPaperAmountPageWeight,
  };
};

export const useCalcSecondFullPaperAmountPageWeight = ({
  poItemSecondFullPaperAmount,
  selectedProduct,
}: {
  poItemSecondFullPaperAmount: number;
  selectedProduct: IProductProperties | null;
}) => {
  const secondFullPaperAmountPageWeight = useMemo(() => {
    const secondFullPaperAmount = poItemSecondFullPaperAmount;
    const process = selectedProduct?.process;
    const gsmStandard = selectedProduct?.material?.gsmStandard;
    return (
      ((gsmStandard ?? 0) *
        (process?.secondFullPaperSize ?? 0) *
        (process?.secondFullPaperLength ?? 0) *
        secondFullPaperAmount) /
      1_000_000_000
    );
  }, [
    poItemSecondFullPaperAmount,
    selectedProduct?.process,
    selectedProduct?.material?.gsmStandard,
  ]);

  return {
    secondFullPaperAmountPageWeight,
  };
};
